import type { TranslateService } from '@ngx-translate/core';
import { EFormInputType, EHtmlAutocompleteAttr, EHtmlInputType, EContactFieldsCrm } from '@common/enums';

export const defaultPaymentWidgetElements = [
    {
        type: EFormInputType.email,
        label: 'Email',
        placeholder: 'username@gmail.com',
        required: true,
        protected: true,
        crmContactVariable: null,
        crmDealVariable: null,
        variable: 'email',
        htmlInputType: EHtmlInputType.email,
        isDynamicPlaceholderEnabled: false,
        autocompleteType: EHtmlAutocompleteAttr.email,
    },
];

export const defaultPaymentWidgetEduElements = (translateService: TranslateService): any[] => [
    {
        type: EFormInputType.email,
        label: 'Email',
        placeholder: 'username@gmail.com',
        required: true,
        protected: true,
        crmContactVariable: null,
        crmDealVariable: null,
        variable: 'email',
        htmlInputType: EHtmlInputType.email,
        autocompleteType: EHtmlAutocompleteAttr.email,
    },
    {
        type: EFormInputType.name,
        label: translateService.instant('control_name'),
        placeholder: translateService.instant('form_default_input_name_placeholder'),
        required: true,
        protected: false,
        crmContactVariable: EContactFieldsCrm.firstName,
        crmDealVariable: null,
        variable: null,
        htmlInputType: EHtmlInputType.text,
        autocompleteType: EHtmlAutocompleteAttr.name,
    },
    {
        type: EFormInputType.input,
        label: translateService.instant('control_second_name'),
        placeholder: translateService.instant('form_default_input_name_placeholder'),
        required: true,
        protected: false,
        crmContactVariable: EContactFieldsCrm.lastName,
        crmDealVariable: null,
        variable: null,
        htmlInputType: EHtmlInputType.text,
        autocompleteType: EHtmlAutocompleteAttr.off,
    },
    {
        type: EFormInputType.phone,
        label: translateService.instant('control_phone'),
        placeholder: '1234567890',
        required: true,
        protected: false,
        crmContactVariable: null,
        crmDealVariable: null,
        variable: 'phone',
        htmlInputType: EHtmlInputType.tel,
        autocompleteType: EHtmlAutocompleteAttr.tel,
    },
];
